export default "__VITE_ASSET__296f9578__"